import useCreditApplications from "hooks/donations/useCreditApplications";
import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

export const ApprovalModal = ({
  showModal,
  setShowModal,
  creditAppId,
  onApproveSuccess,
}) => {
  const [notes, setNotes] = useState("");
  const { addCreditApplicationAction, loading } = useCreditApplications();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!notes.trim()) {
      toast.error("Please provide a note for this action.");
      return;
    }

    const payload = {
      type: "APPROVE",
      notes,
    };

    try {
        const res = await addCreditApplicationAction(creditAppId, payload);
        if (onApproveSuccess) onApproveSuccess(res);
    } catch (err) {
      // error handled inside hook
      console.log(err);
    } finally {
      setShowModal(false);
      setNotes("");
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-2 pt-3 px-4 fw-bold" style={{ fontSize: 14 }}>
        Approve Credit Application
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.83rem" }} className="px-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add a note for the applicant..."
              required
            />
          </Form.Group>

          <div className="d-flex justify-content-start mt-4">
            <Button
              size="sm"
              variant="secondary"
              onClick={() => setShowModal(false)}
              className="me-2"
            >
              Cancel
            </Button>
            {loading ? (
              <Spinner size="sm" animation="border" variant="success" />
            ) : (
              <Button
                size="sm"
                type="submit"
                variant="success"
                disabled={!notes}
              >
                Approve
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
